import React from "react";

const ErrorPage = () => {
  return (
    <div
      className="container-fluid"
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <h2
        className="pagetitle wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        {global.isTokenExpired
          ? "Token Expired! :("
          : global.tokenSamlMismatch
          ? "Your User ID and your token does not match"
          : "Something went wrong! :("}
      </h2>
      <h5
        className=" wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        {global.isTokenExpired || global.tokenSamlMismatch ? (
          <>
            Please <a href={window.REACT_APP_PARTNER_CENTRAL_HOME_URL}>login</a>{" "}
            again with a new token.
          </>
        ) : (
          "We seem to have encountered a problem at our end. Please try again after some time."
        )}
      </h5>
    </div>
  );
};

export default ErrorPage;
